import React from "react";
import { Content, Wrap } from "./styles";
import Slider from "react-slick";
import CardCarousel from "~/shared/CardCarrusel";
import { Container } from "react-bootstrap";

const Partners = () => {
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
        ],
    };

    return (
        <Wrap>
            <Container>
                <Content>
                    <div className="title">
                        <p>
                            Veja quem já
                            <strong> confia no nosso trabalho</strong>
                        </p>
                    </div>
                    <Slider {...settings}>
                        <CardCarousel icon="/images/logo-casa-mineira.png" changeSize={true} />
                        <CardCarousel icon="/images/logo-emcasa.png" changeSize={true} />
                        <CardCarousel icon="/images/logo-loft.png" changeSize={true} />
                        <CardCarousel icon="/images/logo-housi.png" changeSize={true} />
                    </Slider>
                </Content>
            </Container>
        </Wrap>
    );
};

export default Partners;
